import React from 'react';

const headerCell = {
  padding: '8px 10px',
  borderBottom: '1px solid var(--border)',
  textAlign: 'left',
  fontWeight: 600,
  fontSize: 13,
  background: 'var(--table-head-bg)',
  color: 'var(--text)',
};

const bodyCell = {
  padding: '8px 10px',
  borderBottom: '1px solid var(--border)',
  fontSize: 13,
  color: 'var(--text)',
};

export default function PageCountModal({
  open,
  onClose,
  items = [],
  totalPages = 0,
  loading = false,
  error = '',
  warnings = [],
}) {
  if (!open) return null;
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <div className="upload-spinner-overlay" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="upload-spinner-box" style={{ width: 520, maxWidth: '95vw', maxHeight: '80vh', overflow: 'hidden', textAlign: 'left' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <h3 style={{ margin: 0 }}>Page Counts</h3>
          <button className="btn btn-ghost" onClick={onClose}>Close</button>
        </div>
        {loading && (
          <div style={{ padding: '24px 0', textAlign: 'center' }}>
            <div className="spinner-large" style={{ margin: '0 auto 12px' }}></div>
            <div>Calculating page counts…</div>
          </div>
        )}
        {!loading && error && (
          <div style={{ marginTop: 16, background: '#fdecea', color: '#b71c1c', padding: 10, borderRadius: 6 }}>
            {error}
          </div>
        )}
        {!loading && !error && (
          <>
            <div style={{ marginTop: 12, border: '1px solid var(--border)', borderRadius: 6, overflow: 'hidden', maxHeight: '45vh', overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={headerCell}>Filename</th>
                    <th style={{ ...headerCell, width: 120, textAlign: 'right' }}>Pages</th>
                  </tr>
                </thead>
                <tbody>
                  {hasItems ? items.map(item => (
                    <tr key={item.filename}>
                      <td style={bodyCell}>{item.filename}</td>
                      <td style={{ ...bodyCell, textAlign: 'right', fontWeight: 600 }}>
                        {Number(item.pages || 0).toLocaleString()}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan={2} style={{ ...bodyCell, textAlign: 'center', fontStyle: 'italic' }}>No files returned</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontWeight: 600 }}>Total pages:</div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>{Number(totalPages || 0).toLocaleString()}</div>
            </div>
            {!!warnings?.length && (
              <div style={{ marginTop: 12, fontSize: 13, color: '#8a6d3b', background: '#fff3cd', borderRadius: 6, padding: 10 }}>
                {warnings.map((warn, idx) => (
                  <div key={`${warn.filename || 'file'}-${idx}`}>
                    <strong>{warn.filename || 'File'}:</strong> {warn.message || 'Unable to calculate page count'}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
